import { useEffect, useState } from "react";
import { Feature1, Feature2, Feature3, Feature4, Feature5 } from "../assets/images/image";
import { useScrollToSection } from "../hooks/ScrollContext";

const Features = () => {
    const { scrollToSection } = useScrollToSection();
    const [activeIndex, setActiveIndex] = useState(0);
    const [listFeature, setListFeature] = useState([
        {
            id: 1,
            name: "AI-Powered Creation",
            checked: false,
            img: Feature1,
            description: "Generate flashcards instantly from text, documents (PDF, DOCX, TXT), and audio recordings.",
        },
        {
            id: 2,
            name: "Customizable Focus",
            checked: false,
            img: Feature4,
            description: "Tailor your flashcards for any subject, from science and math to languages and history.",
        },
        {
            id: 3,
            name: "Spaced Repetition",
            checked: false,
            img: Feature2,
            description: "Optimized review schedules to maximize long-term retention.",
        },
        {
            id: 4,
            name: "Flexible Learning:",
            checked: false,
            img: Feature5,
            description: "Optimized review schedules to maximize long-term retention.",
        },
        {
            id: 5,
            name: "Teacher Tools",
            checked: false,
            img: Feature3,
            description: "Create and share flashcard sets with your students. ",
        },
    ])
    const [isClicked, setIsClicked] = useState(false);

    const handleChoose = (index: number) => {
        const updated = listFeature.map((item, i) => ({
            ...item,
            checked: i === index,
        }));
        setListFeature(updated);
        setActiveIndex(index);
    };

    useEffect(() => {
        if (isClicked) return;

        const interval = setInterval(() => {
            handleChoose((activeIndex + 1) % listFeature.length);
        }, 3500);

        return () => clearInterval(interval);
    }, [activeIndex, listFeature.length]);

    return (
        <div className="w-full h-full">
            <div className="hidden md:flex items-start p-[100px] h-full">
                <div className="flex w-full gap-x-10">
                    <div className="w-[40%] relative" data-parallax="0.12">
                        {listFeature.map((item, index) => (
                            <img key={index} src={item.img} alt="Feature 1" loading="lazy" className={`w-[80%]  max-h-[500px] object-contain absolute transition-all duration-500 ease-in-out ${index === activeIndex ? "opacity-100 z-10" : "opacity-0 z-0"}`} />
                        ))}
                    </div>
                    <div className="w-[60%] space-y-2">
                        <p className="text-[48px] font-inter font-light text-[#484848]" data-reveal="up">Key Features</p>
                        <div className="flex flex-wrap ">
                            {listFeature.map((item, index) => (
                                <div
                                    key={item.id}
                                    data-reveal="up"
                                    className={`p-4  space-y-4 max-w-[312px] cursor-pointer transition-all duration-500 ease-in-out  ${index === activeIndex ? "cheked-feature" : ""}`}
                                    onClick={() => { handleChoose(index); setIsClicked(true); }}
                                >
                                    <h2 className="text-[17px] font-bold font-inter text-[#484848]">{item.name}</h2>
                                    <p className="text-[17px] font-normal font-inter text-[#484848]">{item.description}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex flex-col items-center gap-y-10 px-4 pt-6 md:hidden">
                <div className="w-full flex items-start">
                    <div className="flex items-center w-full">
                        <span
                            className="text-[17px] font-normal font-inter text-[#484848] cursor-pointer hover:underline bg-[#D9D9D9] me-6 pt-[4px] pb-[4px] ps-[8px] pe-[8px] rounded-[16px]"
                            onClick={() => scrollToSection("home")}
                        >
                            Home
                        </span>
                        <div className="bg-[#FFD600] me-6 pt-[4px] pb-[4px] ps-[8px] pe-[8px] rounded-[16px]">
                            <span className="text-[17px] font-normal font-inter text-[#484848] mx-2">→</span>
                            <span className="text-[17px] font-bold font-inter text-[#484848]">
                                Features
                            </span>
                        </div>
                    </div>
                </div>
                <h2 className="text-[24px] font-light font-inter text-[#484848] text-center" data-reveal="up">
                    Key Features
                </h2>
                {listFeature.map((item, index) => (
                    <div
                        key={item.id}
                        data-reveal="up"
                        className="w-full max-w-[700px] flex flex-col items-center gap-y-4"
                    >
                        <img
                            src={item.img}
                            alt={item.name}
                            loading="lazy"
                            className="w-full object-contain rounded-xl"
                        />
                        <div className="bg-[#F6F6F6] w-full px-4 py-3 rounded-xl text-center">
                            <h3 className="text-[17px] font-bold font-inter text-[#484848] mb-2">
                                {item.name}
                            </h3>
                            <p className="text-[17px] font-normal font-inter text-[#484848]">
                                {item.description}
                            </p>
                        </div>
                        {
                            index !== listFeature.length - 1 && <hr className="w-full border-t border-gray-300" />
                        }
                    </div>
                ))}
            </div>
        </div>
    )
}
export default Features;